export const CHOOSE_ACCOUNT = 'CHOOSE_ACCOUNT';
export const CREATE_USER = 'CREATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const DISABLE_USER = 'DISABLE_USER';
export const ENABLE_USER = 'ENABLE_USER';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCESS_USERS = 'GET_ACCESS_USERS';
export const GRANT_USER_ACCESS = 'GRANT_USER_ACCESS';
export const REMOVE_EXPIRATION = 'REMOVE_EXPIRATION';
export const UPDATE_EXPIRATION = 'UPDATE_EXPIRATION';



// WEBPACK FOOTER //
// ./src/actions/familyAccess/types.js